<template lang='pug'>
HelperToolbar(
  :date='date'
  v-slot='{ dateShort, isNotToday, locationNext, locationPrevious, locationToday }'
)
  v-toolbar(
    dark
    flat
    rounded
  )
    v-menu(
      :close-on-content-click='true'
      transition='scale-transition'
    )
      template(
        v-slot:activator='{ on, attrs }'
      )
        v-btn(
          v-bind='attrs'
          v-on='on'
          text
        )
          | #[v-icon(left) mdi-calendar] {{ dateShort }}
      v-date-picker(
        @change='date => $emit("update:date", date)'
        :allowed-dates='result => result !== date'
      )
    v-btn(
      icon
      text
      :to='locationPrevious'
    )
      v-icon
        | mdi-chevron-left
    v-btn(
      icon
      text
      :to='locationNext'
    )
      v-icon
        | mdi-chevron-right
    template(
      v-if='isNotToday'
      v-slot:extension
    )
      v-btn.accent(
        active-class='d-none'
        block
        depressed
        :to='locationToday'
      )
        | Go to today
</template>

<script>
import HelperToolbar from './HelperToolbar.vue';

export default
{
  components:
  {
    HelperToolbar
  },
  props:
  {
    date: { required: true }
  },
};
</script>